// AUTO-GENERATED by mercato generate registry
import type { NotificationHandler } from '@open-mercato/shared/modules/notifications/handler'

import * as NOTIF_HANDLERS_example_1745 from '../../src/modules/example/notifications.handlers'
type NotificationHandlerEntry = { moduleId: string; handlers: NotificationHandler[] }

export const notificationHandlerEntries: NotificationHandlerEntry[] = [
  { moduleId: 'example', handlers: ((NOTIF_HANDLERS_example_1745.default ?? NOTIF_HANDLERS_example_1745.notificationHandlers ?? []) as NotificationHandler[]) }
]
